import registry from "./dictionaries/registry.uk.json";
import jobber from "./dictionaries/jobber.uk.json";

export const Translator = {
    translate: function translate(path, namespace) {
        namespace = namespace ?? 'registry'
        let result = null
        let legalNamePath = path
        let dictionary = {}
        switch (namespace) {
            case 'registry' :
                legalNamePath = 'registry.Registry.' + path + '.legalName'
                dictionary = registry
                break;
            case 'lease_request' :
                legalNamePath = 'lease_request.LeaseRequest.' + path + '.legalName'
                dictionary = registry
                break;
            case 'action' :
            case 'lease_action' :
                legalNamePath = 'lease_action.LeaseAction.' + path + '.legalName'
                dictionary = registry
                break;
            case 'asset' :
            case 'large_asset' :
                legalNamePath = 'asset.Asset.' + path + '.legalName'
                dictionary = registry
                break;
            case 'large_execution' :
                legalNamePath = 'execution.Execution.' + path + '.legalName'
                dictionary = registry
                break;
            case 'announcement' :
            case 'large_announcement' :
                legalNamePath = 'announcement.Announcement.' + path + '.legalName'
                dictionary = jobber
                break;
            case 'redemption' :
                legalNamePath = 'redemption.Redemption.' + path + '.legalName'
                dictionary = jobber
                break;
        }
        //translate with dictionary:
        result = legalNamePath.split('.').reduce((acc, key) => acc && acc[key], dictionary) ?? result;
        if (result === null) {
            //translate with Base namespace
            legalNamePath = 'base.' + path.charAt(0).toUpperCase() + path.slice(1) + '.legalName'
            result = legalNamePath.split('.').reduce((acc, key) => acc && acc[key], dictionary) ?? result;
        }
        if (result === null) {
            //translate with namespace
            legalNamePath = namespace + '.' + path.charAt(0).toUpperCase() + path.slice(1) + '.legalName'
            result = legalNamePath.split('.').reduce((acc, key) => acc && acc[key], dictionary) ?? result;
        }
        path = path.replace(/\.$/, '').trim();
        if (result === null) {
            // try to translate particularly
            let tmpTranslation = path
            for (let phrase in this.phrases) {
                tmpTranslation = tmpTranslation.replace(phrase, this.phrases[phrase])
            }
            result = tmpTranslation
        }
        result = this.manualNames[path] ?? result
        return result ?? path
    },

    manualNames: {
        //registry object:
        'registryObjectItems': "Об'єкт",
        'This field is required': 'Будь ласка, заповніть це поле',
        'Please fill out this field': 'Будь ласка, заповніть це поле',
        'String value is too short': 'Значення занадто коротке',
        'Not a well-formed email address': 'Значення занадто коротке',
        'String value did not match validation regex': 'Значення не валідне',
        'Not a well-formed URL': 'Необхідно вказати адресу сайту у форматі https://хххххх',
        'Float value should be greater than or equal to 1e-05': 'Значення має бути більше або рівне 1',
        'Float value should be greater than or equal to 1': 'Значення має бути більше або рівне 1',
        'Id required pattern ^[0-9]{8}$ with scheme value UA-EDR': 'Номер документу для схеми ЄДР має складатися з 8 цифр',
        'Could not parse . Should be ISO 8601 or timestamp': 'Дата вказана невірно',

        "Can not parse P as ISO8061 duration type" : 'Невірно заповнений графік оренди',

        'statusesDecisions.culturalHeritage.culturalHeritageCondition': 'Стан пам`ятки культурної спадщини',

        'maximum number of days on week - 7': 'максимальна кількість днів тижня - 7',
        'maximum number of hours on day - 24': 'максимальна кількість годин - 24',

        //redemptions:
        'document with documentType=redemptionNotice is required': 'Завантажте документ з типом "Рішення про приватизацію об\'єкта шляхом викупу"',
        'document with documentType=contractSigned is required': 'Завантажити документ з типом "Підписаний договір',

        //assets:
        'noEncumbrances value not available if hasEncumbrances=True': 'Значення "Обтяження відсутні" недоступне, якщо у відмітці "Присутні обтяження" вказано "Так"',
        "For classificators with '06' at least one of item classificators must be in ['04', '05']": '"При обраному класифікаторі 06 Земельні ділянки обовʼязково необхідно додати лот з класифікатором 04 Нерухоме майно або 05 Цілісний майновий комплекс',

        //announcements
        'tenderPeriod duration should be larger then 3 business days': 'Тривалість періоду між першим/другим та другим/третім повторним аукціоном має бути від 3 до 6 робочих днів',

        relatedOrganizations: "Організації, задіяні в керуванні об'єктом",
        currentTenants: 'Поточні орендарі',
        identifier: "Ідентифікатор організації",
        ownershipType: "Тип власності",
        basicInfo: "Основні характеристики об'єкта",
    },

    translateErrorsArray: function translateErrorsArray(errorsArray, namespace) {
        let result = []
        let flatten = this.flattenObject(errorsArray)
        for (const property in flatten) {
            let prop = property.split('.0').join('')
            prop = prop.split('.1').join('')
            prop = prop.split('.2').join('')
            prop = prop.split('.3').join('')
            prop = prop.split('.4').join('')
            prop = prop.replace('id.id', 'id')

            result.push(`${this.translate(prop, namespace)}: ${this.translate(flatten[property], namespace)}`);
            result = [...new Set(result)]; //remove duplicates
        }
        return result
    },

    phrases: {
        'must be greater than or equal to' : 'Має бути рівним або більше ніж',
        'Must be greater than or equal to' : 'Має бути рівним або більше ніж',
        'Decimal value should be greater than' : 'Має бути більше ніж',
        'value should be greater than' : 'Має бути більше ніж',
        'Value should be greater than' : 'Має бути більше ніж',
        'Value must be one of' : 'Значення має бути одним з',
        '"Value is not int' : 'Значення має бути одним з',
    },

    flattenObject: function flattenObject(obj, parentKey = '') {
        let result = {};

        for (const key in obj) {
            // Ensure the property belongs to the object itself, not its prototype chain
            if (Object.prototype.hasOwnProperty.call(obj, key)) {
                const currentKey = parentKey ? `${parentKey}.${key}` : key;

                if (typeof obj[key] === 'object' && obj[key] !== null) {
                    // Recursively call for nested objects (excluding arrays)
                    let data = obj[key]
                    if (Array.isArray(data)) {
                        data = Object.assign({}, data)
                    }
                    Object.assign(result, flattenObject(data, currentKey));
                } else {
                    // Assign primitive values or arrays directly
                    result[currentKey] = obj[key];
                }
            }
        }
        return result;
    }
}